// extracted by mini-css-extract-plugin
module.exports = {"control":"VipCarousel_control__CgxdD","box":"VipCarousel_box__fGUBD"};